import Axios from 'axios';
import { YouInvest } from 'src/Api';

export default function ScreenerSearch({setLoading, setFundSearch, setScreenerData, selectedFilters, currentPage, selectedFunds, sortOrder, screenerType, rowsPerPage}) {
    let timer = false;
    
    const isValidKeyCode = (keyCode) => {
        return !(keyCode >=9 && keyCode <= 45 && keyCode!=13);
    };

    const searchOnChange = (event) => {
        event.preventDefault();
        const { value } = event.target;
        
        const keyCode = event.which || event.keyCode;
        
        if (isValidKeyCode(keyCode)) {
            clearTimeout (timer);
            if (keyCode==13) {  // enter
                submitSearch(value);
            } else {
                timer = setTimeout(() => submitSearch(value), 300);
            }                
        }
    }

    const submitSearch = async (text) => {
        setLoading(true);
        Axios({
            method: 'POST',
            url: `${process.env.NEXT_PUBLIC_BASE_PATH}/api/screener`,
            data: {
                ...selectedFilters,
                currentPage,
                selectedFunds,
                search: text,
                sortOrder,
                screenerType,
                rowsPerPage
            },
            headers: YouInvest.getTradingRequestHeaders()
        }).then(response => {
            setLoading(false);
            setFundSearch(text);
            setScreenerData(response.data);
        }).catch(error => {
            setLoading(false);
        });
    }

    return <div className="ajb-col-4 ajb-col-8-breakpoint margin-top-20-sm">
        <div className="input-field margin-0">
            <i className="fas fa-search prefix"></i>
            <input onKeyUp={e => searchOnChange(e)} id="icon_prefix" type="text" placeholder="Search investments" />
        </div>
    </div>
}